<template>
  <div class="static_page_loading">
    <v-progress-circular
      indeterminate
      color="#EF3405"
      size="48"
      width="4"
    />
    <p class="static_page_loading__text">{{ $t("STATIC_PAGES.loading") }}</p>
  </div>
</template>

<script>
export default {
  name: "StaticPageLoader",
};
</script>
